import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
///import { spinner, spinnerClose } from '../helpers/spinners';

export const aportesPreafiliadoTraerStart = () => ({ type: types.aportesPreafiliadoTraerStart });
export const aportesPreafiliadoLimpiar = () => ({ type: types.aportesPreafiliadoLimpiar });
export const aportesPreafiliadoTraerError = (error) => ({ type: types.aportesPreafiliadoTraerError,payload: error});
export const aportesPreafiliadoTraerSuccess = (payload) => {
    return {
      type: types.aportesPreafiliadoTraerSuccess,
      payload: payload
    }
  }
  
export const fetchAportesPreafiliado = (CUIL) => {
    return async (dispatch) => {
        dispatch(aportesPreafiliadoTraerStart());
      const response = await fetchConToken(`EmpresasAfiliados/TraerPorCUIL/${CUIL}`);
      if (!response.ok) {
          dispatch(aportesPreafiliadoTraerError(response.statusText));
        throw Error(response.statusText);
      }
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (lista.length>0) {
          dispatch(aportesPreafiliadoTraerSuccess(lista));
        }
      }
    };
  };


  export const fetchUpdateAportes = () => {
    return async (dispatch,getState) => {
      const {items} = getState().empresasPreafiliado;
     dispatch({
       type:types.aportesPreafiliadoUpdate,
       payload:items
     });
    };
  };